import { render, staticRenderFns } from "./companyOwnedBranches.vue?vue&type=template&id=24b4237c&"
import script from "./companyOwnedBranches.vue?vue&type=script&lang=ts&"
export * from "./companyOwnedBranches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports